module.exports = __webpack_public_path__ + "static/automation-ad83924d8e3b8bdf590cef08b6a522c4.jpg";